import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { ITrustedDomainsResponse } from '../models/trusted-domains.model';

export const loadTrustedDomains = createAction('[TrustedDomains] Load TrustedDomains', props<{ businessId: string }>());

export const loadTrustedDomainsSuccess = createAction(
  '[TrustedDomains] Load TrustedDomains Success',
  props<{ response: ITrustedDomainsResponse[] }>()
);

export const loadTrustedDomainsFailure = createAction(
  '[TrustedDomains] Load TrustedDomains Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
